import { RESULTS_PAGE_SIZE } from '@awaze/mfe-common.api.site-search-service';
import { TmsEventType, } from '../DataLayer.types';
import DataLayerBaseEvent from './DataLayerBaseEvent';
export default class SearchPageViewEvent extends DataLayerBaseEvent {
    update(tms, payload, errorHandler) {
        const propertyData = this.getPropertyData(payload.searchCriteria, payload.searchData, payload.pageSize ?? RESULTS_PAGE_SIZE);
        this.updateDataLayer(tms, TmsEventType.link, 'ecommerce-product list', {
            shop_number_of_products: payload.searchData?.total?.toString(),
            ...propertyData,
        }, errorHandler);
    }
}
//# sourceMappingURL=SearchPageViewEvent.js.map